/**
 * 存放关于所处环境判断的方法
 */

/**
 * 判断是在滴滴乘客端内
 * @returns {boolean}
 */
export function inApp() {
  var ua = navigator.userAgent;
  return /didi\.passenger/i.test(ua);
};

/**
 * 判断是在滴滴乘客端顺风车webview内
 * @returns {boolean}
 */
export function inBeatles() {
  var ua = navigator.userAgent;
  return /didi\.passenger.+beatles/i.test(ua);
};

/**
 * 判断是在顺风车独立端内 代号blord
 * @returns {boolean}
 */
export function inBlord() {
  var ua = navigator.userAgent;
  return /didi\.passenger.+beatles\sblord/i.test(ua);
};

/**
 * 判断是ios
 * @returns {boolean}
 */
export function isIos() {
  var ua = navigator.userAgent;
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 判断是安卓
 * @returns {boolean}
 */
export function isAndroid() {
  var ua = navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
}

/**
 * 判断是Fusion容器
 * @returns {boolean}
 */
export function isFusionKit() {
  var ua = navigator.userAgent;
  return /fusionkit/i.test(ua);
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/util/env.js